//import 'core-js/es6/string';
import RootComponent from "../../components/SharedComponents/RootComponent";
import SearchAgent from "../../components/SearchAgent";
import * as Sentry from '@sentry/browser';

if (process.env.RAILS_ENV == 'production') {
    Sentry.init({dsn: "https://a15e533883ac4e09a17ba54ccba0ebdc@o35589.ingest.sentry.io/5260847"});
}

class SearchAgentsRoot extends RootComponent {

    childComponentsMap = [
        {
            dom_container_id: 'search_agents',
            component: SearchAgent,
            props: this.props.searchAgent,
        }
    ]
}

export default SearchAgentsRoot;
